/**
 * HistoryAnimationController
 * #history セクションの要素登場アニメーションを制御する。
 *
 * 挙動:
 *   1. section#history がビューポートに入るのを待つ (section-level IO)。
 *   2. 入った後、各 .slide__horizontal を .slide 内 (横スクロールの viewport)
 *      で監視 (panel-level IO with root=.slide)。
 *   3. panel が横方向に可視領域に入った瞬間 .is-in を付与 (1度きり)。
 *
 * CSS 側 (_front-page.scss) では
 *   .slide__horizontal.is-in .history__img   → scale 0→1 + rotate 0→--rotate
 *   .slide__horizontal.is-in .history__title / __year / __text → opacity 0→1
 * を発火させる。
 */
export const HistoryAnimationController = {
  init() {
    const section = document.getElementById( 'history' );
    if ( !section ) return;
    // PC 用スライド (.history-pc .slide) を対象。SP タイムラインは別演出。
    const slide = section.querySelector( '.history-pc .slide' );
    if ( !slide ) return;
    const panels = slide.querySelectorAll( '.slide__horizontal' );
    if ( !panels.length ) return;

    // section が画面に入るまでは何もしない (先頭 panel が読み込み直後に
    // 勝手にアニメし始めるのを防ぐ)
    const sectionObserver = new IntersectionObserver( ( entries, obs ) => {
      entries.forEach( ( entry ) => {
        if ( !entry.isIntersecting ) return;
        obs.unobserve( section );
        this.observePanels( slide, panels );
      } );
    }, { threshold: 0.15 } );
    sectionObserver.observe( section );
  },

  observePanels( slide, panels ) {
    const panelObserver = new IntersectionObserver( ( entries ) => {
      entries.forEach( ( entry ) => {
        if ( !entry.isIntersecting ) return;
        entry.target.classList.add( 'is-in' );
        panelObserver.unobserve( entry.target );
      } );
    }, { root: slide, threshold: 0.35 } );
    panels.forEach( ( p ) => panelObserver.observe( p ) );
  },
};
